import { render } from "./List.vue?vue&type=template&id=25cb181a"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/DocumentTemplates/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25cb181a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25cb181a', __exports__)) {
    api.reload('25cb181a', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=25cb181a", () => {
    api.rerender('25cb181a', render)
  })

}


export default __exports__